import { render, staticRenderFns } from "./HomePieChart.vue?vue&type=template&id=d545b3b0&scoped=true"
import script from "./HomePieChart.vue?vue&type=script&lang=js"
export * from "./HomePieChart.vue?vue&type=script&lang=js"
import style0 from "./HomePieChart.vue?vue&type=style&index=0&id=d545b3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d545b3b0",
  null
  
)

export default component.exports